.cta-product-selector {
  box-sizing: border-box;
  background-color: white;
  text-decoration: none;
  padding-left: 19px;
  padding-bottom: 20px;
  padding-top: 20px;
  padding-right: 20px;
  border: 2px solid white;
}

.cta-product-selector-dashboard {
  @extend .cta-product-selector;
  height: 100%;
}

.cta-product-selector-dashboard-mobile {
  @extend .cta-product-selector;
  height: 100%;
  padding: 16px;
}

.cta-product-selector-wrapper {
  display: flex;
}

.product-selector-link--full {
  height: 100%;

  .cta-product-selector {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
  }
}

.product-selector-link:focus {
  .cta-product-selector {
    border: 2px solid black;
  }
}

.cta-product-selector:hover {
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.12);
  .support-link {
    text-decoration: underline;
  }
}

.product-selector-header {
  display: flex;
  & .support-icon {
    @extend .support-icon;
    margin-right: 10px;
  }
}

.support-icon {
  margin-left: -8px;
  color: var(--qds-theme-signature-color-default, #008a16);
  &-dashboard {
    @extend .support-icon;
    margin-left: 0;
  }
}
.subtitle1 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  color: #333333;
  margin-bottom: 0;
  &-dashboard {
    @extend .subtitle1;
    margin: 0 12px;
    line-height: 30px;
  }
}

.subtitle2 {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 0px;
  color: #333333;
  &-dashboard {
    @extend .subtitle2;
    margin: 0 12px;
    line-height: 20px;
  }
}

.link-spacer {
  flex-grow: 1;
}

.product-selector-header {
  display: block;
}

.support-link {
  text-decoration: none;
  font-size: 16px;
  margin: 20px 0px 0px 0px;
  color: #1a0dab;
  &-dashboard {
    @extend .support-link;
    display: flex;
    margin: 0;
    justify-content: flex-end;
  }
}

.link {
  text-decoration: none;
}
